// extracted by mini-css-extract-plugin
export default {"add-button":"edit_add-button__YSeyD"};